module.exports = __webpack_public_path__ + "img/UOIM50.f043eca1.png";